/* Casa Manavay · recuadro de compra (Releasit) + urgencia + ruta de entrega + garantía + foto del cierre
   Plazo: 3 a 5 días hábiles a todo Chile. La fecha estimada cuenta 1 día hábil de preparación
   (confirmación interna) + 3 a 5 días hábiles; al cliente solo se le muestra "Pides hoy" y "Recibes".
   Ruta simplificada a 2 pasos (Nicolás, 5 oct 2026): sin paso de WhatsApp, lo más simple posible.
   Garantía: 30 días si llega roto, incompleto o distinto (decisión de Nicolás, 5 oct 2026).
   Cierre de la landing: usa sola la imagen 5 de la galería (mano + pack 2) de cada producto.
   URGENCIA EN 3 NIVELES (Nicolás, 7 oct 2026 19:44), cada uno con un gatillo distinto:
   1) Magnesio = OFERTA DE LANZAMIENTO OFICIAL. Gatillo: escasez. Pack 2 a $36.990 para los primeros
      100 pedidos o hasta el 9 nov 23:59, lo que ocurra primero. Franja lima + cuenta regresiva siempre.
   2) Vitamina C, L-Teanina y Cúrcuma ($21.990). Gatillo: ahorro + continuidad (no cortar la rutina).
      Pack 2 a $34.990 con precio especial hasta el 9 nov. Recuadro marcado, cuenta regresiva los últimos 7 días.
   3) Resto (Colágeno, NAD+, Shilajit, Ashwagandha, Melena, Óxido Nítrico). Gatillo: fecha, sutil.
      Una línea "Precio especial del pack 2 hasta el 9 nov"; cuenta regresiva solo los últimos 7 días.
   Al vencer, todo se oculta solo y queda la línea de entrega. Si el Magnesio llega a 100 pedidos antes:
   MG_CUPOS_ACTIVO = false y subir su pack 2 (Ley 19.496: la condición tiene que ser real). Después del
   9 nov los packs 2 de los 10 deben subir de precio o dejar de llamarse "especial".
   Feriados de Chile cargados hasta julio 2027: actualizar la lista cada año. */
(function(){
  var DIAS_MIN = 3, DIAS_MAX = 5, GARANTIA_DIAS = 30, FOTO_CIERRE = 5;
  var LANZ_ACTIVO = true, LANZ_FIN = '2026-11-09T23:59:59-03:00', LANZ_CUPOS = 100, LANZ_DIAS_CUENTA = 7, MG_CUPOS_ACTIVO = true;
  var FERIADOS = ['2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25',
                  '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21','2027-06-21','2027-06-28','2027-07-16'];
  var MESES = ['ene','feb','mar','abr','may','jun','jul','ago','sept','oct','nov','dic'];
  var DIAS = ['dom','lun','mar','mié','jue','vie','sáb'];

  function iso(d){ return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function habil(d){ var w = d.getDay(); return w !== 0 && w !== 6 && FERIADOS.indexOf(iso(d)) < 0; }
  function sumar(d, n){ var x = new Date(d.getTime()); while(n > 0){ x.setDate(x.getDate() + 1); if(habil(x)){ n--; } } return x; }
  function corto(d){ return DIAS[d.getDay()] + ' ' + d.getDate(); }
  function rango(a, b){ return a.getMonth() === b.getMonth() ? a.getDate() + ' al ' + b.getDate() + ' ' + MESES[b.getMonth()] : a.getDate() + ' ' + MESES[a.getMonth()] + ' al ' + b.getDate() + ' ' + MESES[b.getMonth()]; }
  function pad(n){ return (n < 10 ? '0' : '') + n; }

  function fechas(ahora){
    var hoy = new Date(ahora.getTime()); hoy.setHours(12, 0, 0, 0);
    var conf = sumar(hoy, 1);
    return { hoy: hoy, conf: conf, e1: sumar(conf, DIAS_MIN), e2: sumar(conf, DIAS_MAX) };
  }
  window.cmFechasEntrega = fechas;

  var ico = {
    camion: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    reloj: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    billete: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>',
    escudo: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z"/><path d="M9 12l2 2 4-4"/></svg>',
    rayo: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>',
    etiqueta: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"/><circle cx="7" cy="7" r="1.5"/></svg>'
  };

  /* Ruta de 2 pasos + títulos de packs en blanco */
  function estilosRuta(){
    if(document.getElementById('cm-ruta2-css')) return;
    var st = document.createElement('style'); st.id = 'cm-ruta2-css';
    st.textContent = '.cm-ruta .cm-ruta__line{grid-template-columns:repeat(2,1fr)!important}'
      + '.cm-ruta .cm-ruta__line::before{left:25%!important;right:25%!important;background:linear-gradient(90deg,#C8F135,rgba(200,241,53,.35))!important}'
      /* Títulos de los packs de Releasit siempre en blanco (el seleccionado salía gris sobre negro) */
      + '.cm-buy .rsi-quantity-title-wrapper,.cm-buy .rsi-quantity-title-wrapper *{color:#FFFFFF!important}';
    document.head.appendChild(st);
  }

  function estilosUrg(){
    if(document.getElementById('cm-urg-css')) return;
    var st = document.createElement('style'); st.id = 'cm-urg-css';
    st.textContent = '.cm-urg{margin:0 0 14px!important;padding:13px 15px!important;border-radius:12px!important;border:1px solid rgba(200,241,53,.45)!important;background:rgba(200,241,53,.07)!important;color:#FFFFFF!important;font-family:Inter,system-ui,sans-serif!important;text-align:left!important}'
      + '.cm-urg *{color:inherit!important}'
      + '.cm-urg [hidden]{display:none!important}'
      + '.cm-urg__t{display:flex!important;align-items:center!important;gap:8px!important;margin:0 0 6px!important;color:#C8F135!important}'
      + '.cm-urg__t svg{width:18px!important;height:18px!important;flex:0 0 18px!important}'
      + '.cm-urg__t b{font:900 19px/1 "Barlow Condensed","Arial Narrow",sans-serif!important;letter-spacing:.06em!important;text-transform:uppercase!important}'
      + '.cm-urg__reloj{display:flex!important;align-items:baseline!important;flex-wrap:wrap!important;gap:4px 8px!important;margin:2px 0 6px!important;font:700 13.5px/1.3 Inter,sans-serif!important}'
      + '.cm-urg__reloj strong{font:900 24px/1 "Barlow Condensed","Arial Narrow",sans-serif!important;font-variant-numeric:tabular-nums!important;letter-spacing:.03em!important}'
      + '.cm-urg__txt{margin:0 0 9px!important;font-size:13.5px!important;line-height:1.45!important}'
      + '.cm-urg__txt b{font-weight:800!important}'
      + '.cm-urg__envio{display:flex!important;align-items:center!important;gap:8px!important;margin:0!important;padding-top:9px!important;border-top:1px solid rgba(255,255,255,.14)!important;font-size:13px!important;line-height:1.35!important}'
      + '.cm-urg__envio svg{width:17px!important;height:17px!important;flex:0 0 17px!important}'
      + '.cm-urg--solo{padding:10px 14px!important}.cm-urg--solo .cm-urg__envio{padding-top:0!important;border-top:0!important}'
      /* Nivel 1 · Magnesio: franja lima fuerte (escasez) */
      + '.cm-urg--mg{background:#C8F135!important;border-color:#C8F135!important;color:#0D0D0D!important;box-shadow:0 0 0 0 rgba(200,241,53,0);animation:cmUrgPulso 2.4s ease-in-out infinite}'
      + '.cm-urg--mg .cm-urg__t{color:#0D0D0D!important}'
      + '.cm-urg--mg .cm-urg__t b{font-size:21px!important}'
      + '.cm-urg--mg .cm-urg__reloj strong{font-size:28px!important}'
      + '.cm-urg--mg .cm-urg__envio{border-top-color:rgba(0,0,0,.18)!important}'
      + '.cm-urg--mg.cm-urg--solo{background:rgba(200,241,53,.07)!important;border-color:rgba(200,241,53,.45)!important;color:#FFFFFF!important;animation:none}'
      /* Nivel 2 · productos de $21.990: ahorro + continuidad */
      + '.cm-urg--ent{border:1.5px solid #C8F135!important;background:rgba(200,241,53,.09)!important}'
      + '.cm-urg--ent .cm-urg__ahorro{display:flex!important;align-items:baseline!important;flex-wrap:wrap!important;gap:4px 10px!important;margin:0 0 6px!important}'
      + '.cm-urg--ent .cm-urg__ahorro strong{font:900 26px/1 "Barlow Condensed","Arial Narrow",sans-serif!important;color:#C8F135!important;font-variant-numeric:tabular-nums!important}'
      + '.cm-urg--ent .cm-urg__ahorro span{font-size:13px!important;opacity:.75!important}'
      + '.cm-urg--ent.cm-urg--solo{border:1px solid rgba(200,241,53,.45)!important;background:rgba(200,241,53,.07)!important}'
      /* Nivel 3 · resto: línea sutil */
      + '.cm-urg--sut{border:1px solid rgba(255,255,255,.12)!important;background:transparent!important;padding:11px 14px!important}'
      + '.cm-urg--sut .cm-urg__nota{display:flex!important;align-items:center!important;gap:8px!important;margin:0 0 8px!important;font-size:13px!important;line-height:1.4!important;opacity:.85!important}'
      + '.cm-urg--sut .cm-urg__nota svg{width:15px!important;height:15px!important;flex:0 0 15px!important;color:#C8F135!important}'
      + '.cm-urg--sut .cm-urg__nota b{color:#C8F135!important;font-weight:700!important}'
      + '.cm-urg--sut .cm-urg__reloj strong{font-size:20px!important}'
      + '@keyframes cmUrgPulso{0%,100%{box-shadow:0 0 0 0 rgba(200,241,53,0)}50%{box-shadow:0 0 0 6px rgba(200,241,53,.2)}}'
      + '@media (prefers-reduced-motion:reduce){.cm-urg--mg{animation:none}}';
    document.head.appendChild(st);
  }

  function urgencia(hd){
    var esMg = /magnesio/i.test(location.pathname);
    var esEnt = /theanina|vitamina-c|curcuma/i.test(location.pathname);
    var fin = new Date(LANZ_FIN).getTime();
    var vigente = LANZ_ACTIVO && !isNaN(fin) && Date.now() < fin && (!esMg || MG_CUPOS_ACTIVO);
    var f = fechas(new Date());
    estilosUrg();

    var nivel = esMg ? ' cm-urg--mg' : (esEnt ? ' cm-urg--ent' : ' cm-urg--sut');
    var u = document.createElement('div');
    u.className = 'cm-urg' + nivel + (vigente ? '' : ' cm-urg--solo');
    var reloj = '<div class="cm-urg__reloj" data-cm-lanz' + (esMg ? '' : ' data-cm-ultimos hidden') + '>Termina en <strong data-cm-reloj></strong></div>';
    var html = '';
    if(vigente){
      if(esMg){
        html += '<div class="cm-urg__t" data-cm-lanz>' + ico.rayo + '<b>Oferta de lanzamiento</b></div>'
          + reloj
          + '<p class="cm-urg__txt" data-cm-lanz>Pack 2 a <b>$18.495 por frasco</b>. Solo para los primeros <b>' + LANZ_CUPOS + ' pedidos</b> o hasta el <b>9 de noviembre</b>, lo que ocurra primero.</p>';
      } else if(esEnt){
        html += '<div class="cm-urg__ahorro" data-cm-lanz><strong>Ahorras $8.990</strong><span>llevando 2 frascos por $34.990</span></div>'
          + '<p class="cm-urg__txt" data-cm-lanz>Cada frasco te queda en <b>$17.495</b> y tienes el doble sin volver a pedir: no cortas tu rutina a mitad de camino. Precio especial del pack 2 hasta el <b>9 de noviembre</b>.</p>'
          + reloj;
      } else {
        html += '<p class="cm-urg__nota" data-cm-lanz>' + ico.etiqueta + '<span>Precio especial del pack 2 hasta el <b>9 de noviembre</b>.</span></p>'
          + reloj;
      }
    }
    html += '<p class="cm-urg__envio">' + ico.camion + '<span>Si lo pides hoy, te llega del <b>' + rango(f.e1, f.e2) + '</b></span></p>';
    u.innerHTML = html;
    hd.parentNode.insertBefore(u, hd.nextSibling);
    if(!vigente) return;

    var rel = u.querySelector('[data-cm-reloj]');
    var ultimos = u.querySelector('[data-cm-ultimos]');
    var t;
    function tick(){
      var resta = fin - Date.now();
      if(resta <= 0){
        [].slice.call(u.querySelectorAll('[data-cm-lanz]')).forEach(function(n){ n.parentNode.removeChild(n); });
        u.classList.add('cm-urg--solo');
        clearInterval(t); return;
      }
      if(ultimos){ ultimos.hidden = resta > LANZ_DIAS_CUENTA * 86400000; }
      var s = Math.floor(resta / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sg = s % 60;
      if(rel) rel.textContent = (d > 0 ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(m) + ':' + pad(sg);
    }
    tick(); t = setInterval(tick, 1000);
  }

  var intentos = 0;
  function armar(){
    var w = document.querySelector('.rsi_embedded_quantity_wrapper');
    var caja = w && w.closest('.product-form__buttons');
    if(!caja){ if(intentos++ < 60){ setTimeout(armar, 250); } return; }
    if(caja.classList.contains('cm-buy')) return;
    caja.classList.add('cm-buy');
    estilosRuta();

    var hd = document.createElement('div'); hd.className = 'cm-buy__hd';
    hd.innerHTML = '<b>Elige tu pack</b><span>Precio final · envío incluido</span>';
    caja.insertBefore(hd, caja.firstChild);
    urgencia(hd);

    var info = document.createElement('div'); info.className = 'cm-info';
    info.innerHTML = '<div class="cm-info__it">' + ico.camion + '<span>Envío gratis<b>a todo Chile</b></span></div>'
      + '<div class="cm-info__it">' + ico.escudo + '<span>Garantía<b>de ' + GARANTIA_DIAS + ' días</b></span></div>'
      + '<div class="cm-info__it">' + ico.reloj + '<span>Llega en<b>' + DIAS_MIN + ' a ' + DIAS_MAX + ' días hábiles</b></span></div>'
      + '<button type="button" class="cm-info__it" data-cm-pago>' + ico.billete + '<span>Pago al recibir<b>¿Cómo funciona?</b></span></button>';
    caja.appendChild(info);

    var f = fechas(new Date());
    var ruta = document.createElement('div'); ruta.className = 'cm-ruta';
    ruta.innerHTML = '<div class="cm-ruta__hd">' + ico.camion
      + '<span><em class="cm-ruta__gratis">Envío gratis</em>Llega en <b>' + DIAS_MIN + ' a ' + DIAS_MAX + ' días hábiles</b><small>A todo Chile, de Arica a Punta Arenas</small></span></div>'
      + '<ol class="cm-ruta__line">'
      + '<li class="cm-ruta__p is-on"><i></i><b>Pides</b><span>Hoy, ' + corto(f.hoy) + '</span></li>'
      + '<li class="cm-ruta__p is-end"><i></i><b>Recibes</b><span class="cm-ruta__fecha">' + rango(f.e1, f.e2) + '</span></li>'
      + '</ol>'
      + '<p class="cm-ruta__pie">Fecha aproximada · pagas cuando lo recibes</p>'
      + '<div class="cm-gar">' + ico.escudo + '<span><b>Garantía de ' + GARANTIA_DIAS + ' días</b>Si tu pedido llega roto, incompleto o distinto, avísanos y te lo cambiamos sin costo.</span></div>';
    caja.appendChild(ruta);

    info.querySelector('[data-cm-pago]').addEventListener('click', function(){
      var d = [].slice.call(document.querySelectorAll('.lp-faq details')).filter(function(x){ return /pedido y el pago/i.test(x.textContent); })[0];
      if(!d) return;
      d.open = true;
      var y = d.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* Foto del cierre: la imagen 5 de la galería (mano + pack 2), igual en todas las landings */
  var intentosFoto = 0;
  function cierreFoto(){
    var ci = document.querySelector('.lp-ci');
    var imgs = document.querySelectorAll('.product__media-list .product__media-item img');
    if(!ci || !imgs.length){ if(intentosFoto++ < 40){ setTimeout(cierreFoto, 300); } return; }
    if(ci.classList.contains('lp-ci--foto')) return;
    var img = imgs[FOTO_CIERRE - 1] || imgs[imgs.length - 1];
    var src = img.getAttribute('src') || img.currentSrc;
    if(!src) return;
    src = src.replace(/([?&])width=\d+/, '$1width=900');
    if(!document.getElementById('cm-ci-css')){
      var st = document.createElement('style'); st.id = 'cm-ci-css';
      st.textContent = '.lp-ci.lp-ci--foto .lp-ci__foto{position:relative;z-index:1;width:min(320px,82%);margin:0 auto 22px;border-radius:18px;overflow:hidden;border:1px solid rgba(200,241,53,.4);box-shadow:0 20px 50px rgba(0,0,0,.5),0 0 40px rgba(200,241,53,.12)}'
        + '.lp-ci.lp-ci--foto .lp-ci__foto img{display:block;width:100%;height:auto;aspect-ratio:1/1;object-fit:cover}'
        + '.lp-ci.lp-ci--foto .lp-ci__txt{position:relative;z-index:1}'
        + '@media (min-width:750px){.lp-ci.lp-ci--foto{display:grid!important;grid-template-columns:minmax(0,.9fr) minmax(0,1.1fr);gap:44px;align-items:center}.lp-ci.lp-ci--foto .lp-ci__foto{width:100%;max-width:420px;margin:0 0 0 auto}}';
      document.head.appendChild(st);
    }
    var txt = document.createElement('div'); txt.className = 'lp-ci__txt';
    [].slice.call(ci.children).forEach(function(n){ if(!n.classList.contains('lp-ci__marca')){ txt.appendChild(n); } });
    var foto = document.createElement('div'); foto.className = 'lp-ci__foto';
    foto.innerHTML = '<img src="' + src + '" alt="Pack de 2 frascos" loading="lazy" width="900" height="900">';
    ci.appendChild(foto);
    ci.appendChild(txt);
    ci.classList.add('lp-ci--foto');
  }

  function iniciar(){ armar(); cierreFoto(); }
  if(typeof document !== 'undefined'){
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
  }
})();
